module.exports = "pegasus/assets/gray-ghost-facebook.png";